//------------------
// is skill changed
//------------------
export default function isSkillChanged(original, now) {
  console.log('----------------------------')
  console.log('IN isSkillChanged')

  if (
    original.ticks != now.ticks ||
    original.training != now.training ||
    Boolean(original.favourite) !== Boolean(now.favourite)
  ) {
    console.log('VALUE CHANGED ', original.name)
    return true
  } else {
    console.log('VALUE NOT CHANGED ', original.name)
    return false
  }
}
